var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3SuspensionLampOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7v62h62V7H7zm58 58H11V11h25v16.9c-7.89.88-14 6.85-14 14.1h8.85a7.33 7.33 0 1014.42 0H54c0-7.25-6.11-13.22-14-14.1V11h25v54zM41.12 42A3.33 3.33 0 1135 42h6.12z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Suspension_lamp_off.d62fc10a.svg";
export { SvgA3SuspensionLampOff as ReactComponent };